import { FieldActionOnValuesFunction } from '../types';
import { RequestToVaryDeclarationModel } from '../../api/models/requestToVary';
import { standardTitleOptions } from '../title';

export const requestToVaryDeclaration: FieldActionOnValuesFunction<RequestToVaryDeclarationModel> = {
    declarantTitle: standardTitleOptions,
};
